import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AuthService, ConfigServerService, CustomHttp } from '../../../../../core';
import { NegocioQualificacaoCreate } from '../negocio-qualificacao-create';
import { NegocioQualificacaoSearch } from '../negocio-qualificacao-search';

@Injectable({
    providedIn: 'root'
})
export class NegocioQualificacaoCreateHttpService {
    private pathApi: string;

    constructor(private authService: AuthService,
                configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/crm/negocioqualificacao`;
    }

    /** Cria um negócio a ser qualificado */
    create(create: NegocioQualificacaoCreate): Observable<NegocioQualificacaoSearch> {
        return this.customHttp.post<NegocioQualificacaoSearch>(this.pathApi, create);
    }
}
